
/**
 * 手机号码正则匹配
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function phoneRule(rule, value, callback) {
    if (!rule.required && !value) {
        return callback();
    }
    if (!value) {
        callback(new Error('请输入手机号码'))
    } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
            callback()
        } else {
            return callback(new Error('请输入正确的手机号码'))
        }
    }
}

/**
 * 匹配1~n正整数
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function positiveIntegerRule(rule, value, callback) {
    if (!rule.required && !value) {
        return callback();
    }
    if (!value) {
        callback(new Error('请输入'))
    } else {
        const reg = /^[1-9]\d*$/
        if (reg.test(value)) {
            callback()
        } else {
            return callback(new Error('请输入正确的正整数数值'))
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/regMatch.js